import { dmApi } from "../dmApi";
import { handleQueryErrorAndSuccess, getAuthorizationHeader } from "../../helpers/RtkQueryUtils";

const stageMappingApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        getMappingList: build.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/admin/get-all-oddo-stage-mappings?page=${page}&limit=${limit}&searchTerm=${search}`,
                method: "GET",
                headers: getAuthorizationHeader()
            }),
            providesTags: ['getMappingListApi']
        }),
        getMappingListById: build.query({
            query: ({ stageId }) => ({
                url: `/admin/get-stage-mapping-by-id?stageId=${stageId}`,
                method: "GET",
                headers: getAuthorizationHeader()
            }),
            providesTags: ['getMappingListApi']
        }),
        createMapping: build.mutation({
            query: () => ({
                url: "/admin/add-oddo-stage-mapping",
                method: "POST",
                headers: getAuthorizationHeader()
            }),
            invalidatesTags: ['getMappingListApi'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, '', 'Stage mapping synced');
            },
        }),
        createLabel: build.mutation({
            query: () => ({
                url: "/admin/create-label",
                method: "POST",
                headers: getAuthorizationHeader()
            }),
            invalidatesTags: ['getMappingListApi'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, '', 'Label created');
            },
        }),
        updateMapping: build.mutation({
            query: ({ stageId, formData }) => ({
                url: `/admin/update-oddo-stage-by-id?stageLabelId=${stageId}`,
                method: "PUT",
                body: formData,
                headers: getAuthorizationHeader()

            }),
            invalidatesTags: ['getMappingListApi'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, '', 'Survey updated');
            },
        }),
        switchLabel: build.mutation({
            query: ({ body }) => ({
                url: `/admin/switch-stage-label`,
                method: "PUT",
                body: body,
                headers: getAuthorizationHeader()

            }),
            invalidatesTags: ['getMappingListApi'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, '', 'Stage moved to new label');
            },
        }),
        switchLabelParent: build.mutation({
            query: ({ body }) => ({
                url: '/admin/switch-label',
                method: "PUT",
                body: body,
                headers: getAuthorizationHeader()
            }),
            invalidatesTags: ['getMappingListApi'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, '', 'Label sequence changed');
            },
        }),
        deleteLabel: build.mutation({
            query: ({ stageId }) => ({
                url: `/admin/delete-label?labelId=${stageId}`,
                method: "DELETE",
                headers: getAuthorizationHeader()

            }),
            invalidatesTags: ['getMappingListApi'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, '', 'Label deleted');
            },
        })

    })
})

export const { useGetMappingListQuery, useGetMappingListByIdQuery, useUpdateMappingMutation, useCreateMappingMutation, useCreateLabelMutation, useSwitchLabelMutation, useSwitchLabelParentMutation, useDeleteLabelMutation } = stageMappingApi